import * as moment from 'moment'
import { TracepointRule } from '../../../domain/TracepointRule'
import httpBuildQuery from '../../../httpBuildQuery'
import { TracepointFormState } from '../../../monitor/operation/tracepoint-form/tracepoint-form-fields'
import { FetchTraceHistoryParameters } from '../Trace/actions'

export const FETCH_TRACE_BOOST = 'V2/TracepointRule/FetchById'
export const FETCH_TRACE_BOOSTS = 'V2/TracepointRule/Fetch'
export const FETCH_ACTIVE_TRACE_BOOSTS = 'V2/TracepointRule/FetchActive'
export const ADD_TRACE_BOOST = 'V2/TracepointRule/Add'
export const UPDATE_TRACE_BOOST = 'V2/TracepointRule/Update'
export const TERMINATE_TRACE_BOOST = 'V2/TracepointRule/Terminate'

export interface FetchTracepointParameters {
    environment: string
    service: string
}

export const fetchTracepoint = (tracepointId: string) => ({
    type: FETCH_TRACE_BOOST,
    payload: ({ fetchForApplication }) => fetchForApplication(`/tracepoint-rules/${tracepointId}`),
})

export const fetchTracepoints = ({ environment, service }: FetchTraceHistoryParameters) => ({
    type: FETCH_TRACE_BOOSTS,
    payload: ({ fetchForApplication }) => fetchForApplication(`/tracepoint-rules?env=${environment}&s=${service}`),
})

export const fetchActiveTracepoints = ({ environment, service }: FetchTraceHistoryParameters) => ({
    type: FETCH_ACTIVE_TRACE_BOOSTS,
    payload: ({ fetchForApplication }) => fetchForApplication(`/tracepoint-rules?env=${environment}&s=${service}&active=1`),
})

export const addTracepoint = (transactionId: number, environment: string, service: string, data: TracepointFormState) => ({
    type: ADD_TRACE_BOOST,
    payload: ({ fetchForApplication }) =>
        fetchForApplication(`/transaction/${transactionId}/tracepoint-rule?env=${environment}&s=${service}`, {
            method: 'POST',
            body: httpBuildQuery(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }),
})

export const updateTracepoint = (tracepoint: TracepointRule<moment.Moment>, data: TracepointFormState) => ({
    type: UPDATE_TRACE_BOOST,
    payload: ({ fetchForApplication }) =>
        fetchForApplication(`/transaction/${tracepoint.transactionId}/tracepoint-rule/${tracepoint.id}`, {
            method: 'POST',
            body: httpBuildQuery(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        }),
})

export const terminateTracepoint = (tracepoint: TracepointRule<moment.Moment>) => ({
    type: TERMINATE_TRACE_BOOST,
    payload: async ({ fetchForApplication }) =>
        fetchForApplication(`/transaction/${tracepoint.transactionId}/tracepoint-rule/${tracepoint.id}/terminate`, { method: 'POST' }),
})
